import React from 'react';
import { createRoot } from 'react-dom/client';

import '@/shared/config/dayjs';
import { App } from '@/app/App';

import 'antd/dist/reset.css';
import './index.css';
import './shared/styles/styles.scss';

// Handle chunk loading errors after deployment
const RELOAD_KEY = 'chunk-error-reloaded';

const handleChunkError = (message: string) => {
  const msg = message || '';

  // Only chunk-related errors
  const isChunkLoadError =
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('CSS chunk') ||
    msg.includes('import() failed');

  // Network issues: reloading usually won't help
  const isNetworkError =
    msg.includes('ERR_INTERNET_DISCONNECTED') ||
    msg.includes('ERR_NETWORK_CHANGED') ||
    msg.includes('NetworkError') ||
    msg.includes('Failed to fetch');

  if (
    isChunkLoadError &&
    !isNetworkError &&
    !sessionStorage.getItem(RELOAD_KEY)
  ) {
    sessionStorage.setItem(RELOAD_KEY, 'true');
    console.warn('Chunk load error detected, reloading page...');
    window.location.reload();
  }
};

window.addEventListener('error', (event) => {
  handleChunkError((event as ErrorEvent).error?.message || event.message || '');
});

window.addEventListener('unhandledrejection', (event) => {
  const { reason } = event;
  handleChunkError(reason?.message || String(reason || ''));
});

window.addEventListener('load', () => {
  sessionStorage.removeItem(RELOAD_KEY);
});

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
